import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { DownloadProjectImagesVM, elementIsChecked } from './DownloadProjectImagesVM';
import { CollapseTable } from 'cd-eft/components/common/CollapseTable';
import { Row, Col } from 'reactstrap';
import { OUTPUT_IMAGE_TYPES } from '../DownloadProject/DownloadProject.config';
import stores from '../../../models/Stores';

const { projectsLibraryStore: libraryStore } = stores.AppStore;

interface IDownloadProjectImagesProps {
  type: any;
  element: any;
  someChangesOnScreen: () => void;
}

export const DownloadProjectImages = observer((props: IDownloadProjectImagesProps) => {
  const vm = useRef(new DownloadProjectImagesVM(props)).current;
  const { type, element } = props;

  const name = element.designElementName;
  const id = element.designElementId;
  const images = element.images;

  return (
    <>
      {images ? (
        // Level 2 - structure, if it has images
        <CollapseTable
          title={`${name}`}
          bodyContainerId={`${type.designElementTypeId}-${id}-summary`}
          value={`element-${id}`}
          isOpen={true}
          checked={elementIsChecked(element)}
          onChange={(e) => vm.selectStructure(e, element)}
          showAdded={false}
        >
          {Object.keys(images).map((key) => (
            <React.Fragment key={key}>
              {images[key] && images[key].length > 1 ? (
                // Level 3 - image type with more then one images
                <>
                  <CollapseTable
                    title={`${OUTPUT_IMAGE_TYPES[key]}`}
                    bodyContainerId={`${type.designElementTypeId}-${id}-${key}-summary`}
                    value={`imagetype-${key}`}
                    isOpen={true}
                    checked={
                      images[key].some((el) => !libraryStore.selectedImages.includes(el.structureProfilesId))
                        ? false
                        : true
                    }
                    onChange={(e) => vm.selectImageType(e, images[key], element)}
                    showAdded={false}
                  >
                    {images[key].map((el) => (
                      <InfoRowWithSelection
                        key={`${el.designElementTypeId}-${el.designElementId}-${key}-${el.structureProfilesId}`}
                        value={el.structureProfilesId}
                        id={`${el.designElementTypeId}-${el.designElementId}-${key}-${el.structureProfilesId}`}
                        name={`img ${el.structureProfilesId}`}
                        isDisabled={el.isDisabled}
                        selectImage={(e) => vm.selectImage(e, element)}
                        level={4}
                      />
                    ))}
                  </CollapseTable>
                </>
              ) : images[key].length === 1 ? (
                images[key].map((el) => (
                  // Level 3 - image type with only one image
                  <InfoRowWithSelection
                    key={`${el.designElementTypeId}-${el.designElementId}-${key}-${el.structureProfilesId}`}
                    value={el.structureProfilesId}
                    id={`${el.designElementTypeId}-${el.designElementId}-${key}-${el.structureProfilesId}`}
                    name={`${OUTPUT_IMAGE_TYPES[key]}`}
                    isDisabled={el.isDisabled}
                    selectImage={(e) => vm.selectImage(e, element)}
                    level={3}
                  />
                ))
              ) : null}
            </React.Fragment>
          ))}
        </CollapseTable>
      ) : (
        // Level 2 - structure, if no images
        <InfoRowWithSelection
          key={`${type.designElementType}-${id}`}
          id={`${type.designElementTypeId}-${id}`}
          value={`element-${id}`}
          name={`${name}`}
          isDisabled={element.isDisabled || !images}
          selectImage={(e) => vm.selectImage(e, element)}
          level={2}
        />
      )}
    </>
  );
});

const InfoRowWithSelection = observer(({ value, id, name, isDisabled, selectImage, level }) => {
  return (
    <Row>
      <Col>
        <input
          id={id}
          name={id}
          data-testid={id}
          type="checkbox"
          value={value}
          checked={libraryStore.selectedImages.includes(+value)}
          onChange={selectImage}
          disabled={isDisabled}
          className={`level${level}`}
        />
        <label htmlFor={id}>{name ? name : 'Name-' + id}</label>
      </Col>
    </Row>
  );
});
